// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { nativeScrollViewProps } from 'components/common/scroll/TreactNativeScrollStyles';
import { AlgorithmResults } from '@tls/sw91-communication/types/com.api_predictor';
import styled from 'styled-components';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '@tls/treact-ui';
import { QCPContext } from '@tls/sw91_ui_templates';
import { getAlgorithmResultName } from './getAlgorithmResultName';

// Subscribe to resource updates as plugin translations are registered asynchronously.
const translationOptions = {
  bindI18n: 'languageChanged loaded',
  bindI18nStore: 'added removed',
};

interface Props {
  algorithmResults: AlgorithmResults[];
}
const AlgorithmResultsTable = ({ algorithmResults }: Props) => {
  const { t } = useTranslation(undefined, translationOptions);
  const { qcpProject, plugins } = useContext(QCPContext);
  const entries = algorithmResults.map((result, index) => ({
    key: `${result.algorithmName ?? ''}-${index}`,
    name: getAlgorithmResultName(result.algorithmName, qcpProject, plugins, t),
    ok: result.ok,
    nok: result.nok,
  }));

  return (
    <Root>
      <Table>
        <Table.Header>
          <Table.HeaderRow>
            <Table.HeaderCell width={1} isGroupEnd>
              {t('project.evaluation.qc.overviewTable.name')}
            </Table.HeaderCell>
            <Table.HeaderCell width={'4rem'}>{t('project.evaluation.qc.overviewTable.ok')}</Table.HeaderCell>
            <Table.HeaderCell width={'4rem'}>{t('project.evaluation.qc.overviewTable.nok')}</Table.HeaderCell>
          </Table.HeaderRow>
        </Table.Header>
        <Table.ScrollingBody scrollViewProps={nativeScrollViewProps}>
          {entries.map(result => (
            <Table.Row key={result.key}>
              <Table.Cell width={1} isGroupEnd>
                {result.name}
              </Table.Cell>
              <Table.Cell alignment='CENTER' width={'4rem'}>
                {result.ok}
              </Table.Cell>
              <Table.Cell alignment='CENTER' width={'4rem'}>
                {result.nok}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.ScrollingBody>
      </Table>
    </Root>
  );
};
const Root = styled.div`
  height: calc(100% - 1rem);
  overflow: hidden;
  padding: 1rem;
`;

export default AlgorithmResultsTable;
